import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';
import { LOAD_DOCUMENT_LIST } from '../type';
import {
  loadDocumentListSuccessAction,
  loadDocumentListErrorAction,
} from '../action';

import { consultationService } from 'services';

function* loadDocumentList() {
  while (1) {
    const action = yield take(LOAD_DOCUMENT_LIST);
    try {
      const consultationDetails = yield call(
        consultationService.loadConsultationDetail,
        action.payload,
      );
      if (consultationDetails) {
        const documentList = yield call(consultationService.loadDocumentList, {
          ...action.payload,
          consultationId: consultationDetails.id,
          patientUuid: action.payload.patientUuid,
        });
        yield put(loadDocumentListSuccessAction(documentList));
      }
    } catch (err) {
      yield put(loadDocumentListErrorAction(err.message));
      notification.error({
        message: err.message,
      });
    }
  }
}

export default function* rootSaga() {
  yield all([loadDocumentList()]);
}
